import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ConfigService, ListadaAgrupada } from "../../infrastructure/services/config.service";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs";

@Component({
  selector: "sx-configurar-channel",
  templateUrl: "./configuration.center.component.html"
})
export class ConfigurationCenterComponent implements OnInit {
  title: "CENTER";

  grupos: Observable<ListadaAgrupada[]>;
  cargando: Boolean = true;
  subsGetConfiguracion: Subscription;
  constructor(
    private aRoute: ActivatedRoute,
    private configService: ConfigService
  ) {}

  ngOnInit() {
    const { title } = this.aRoute.snapshot.data;
    if (title) {
      this.title = title;
    }

    this.aRoute.params.subscribe((params: Params) => {
      // Parametros URL
      this.grupos = this.configService.getConfiguracion();
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuration-center/configuration.center.component.ts